import { ICellRendererParams } from 'ag-grid-enterprise';
import { ETLDataFeedObj } from '../../cxone-etl-data-feed/cxone-etl-data-feed.model';
import { ETLDataRecalculationObj } from '../../cxone-etl-recalculation/cxone-etl-data-recalculation/cxone-etl-data-recalculation.model';
export enum IconType {
    Inactive,
    Failed,
    None
}

export interface IconDetail {
    iconType: IconType;
    popoverMsg?: string;
}

export interface CustomCellRendererParams extends ICellRendererParams {
    iconPath?: (data: ETLDataFeedObj) => IconDetail;
    showTextPopover?: boolean;
    convertedValue?: (data: ETLDataRecalculationObj) => string;
}
